export const navLinks = [
  { label: "翻车现场", hash: "#scene" },
  { label: "名场面大赏", hash: "#moments" },
  { label: "热度榜", hash: "#rank" },
  { label: "实录档案", hash: "#archive" },
  { label: "栏目专区", hash: "#topics" },
];

export const trendTicker = [
  "发布会大屏失控的十分钟",
  "带货话术卡壳名场面",
  "街头挑战 100 秒崩盘",
  "AI 字幕当场念串台词",
  "盲盒开出\u201c空气\u201d名场面",
  "无人机编队突发撞机",
];

export const heroCovers = [
  {
    tag: "直播 · 头版",
    title: "系统宕机的一瞬，弹幕反而刷到顶峰",
    source: "直播实录馆",
    time: "12 分钟前",
    views: "实时围观 236 万",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20photo%20of%20a%20chaotic%20live%20broadcast%20studio%20freeze%20frame%2C%20an%20overturned%20ring%20light%20casting%20warm%20glow%2C%20scattered%20script%20pages%20and%20a%20tipped%20coffee%20cup%20suspended%20mid%20air%2C%20a%20silhouetted%20presenter%20spinning%20away%20from%20camera%2C%20cinematic%20warm%20amber%20and%20rust%20tones%2C%20high%20contrast%20dramatic%20side%20light%2C%20stylized%20editorial%20aesthetic%20with%20soft%20film%20grain%2C%20no%20readable%20text%2C%20no%20identifiable%20face%2C%20generous%20negative%20space%20at%20top&width=900&height=1200&seq=hero-cover-01&orientation=portrait",
  },
  {
    tag: "舞台 · 名场面",
    title: "发布会演示到一半，全场安静了三秒",
    source: "舞台档案",
    time: "38 分钟前",
    views: "实时围观 178 万",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20photo%20of%20a%20stage%20presentation%20freeze%20frame%2C%20a%20single%20spotlight%20beam%20hitting%20an%20empty%20podium%20with%20a%20drifting%20remote%20controller%20floating%20in%20air%2C%20dark%20auditorium%20silhouettes%20in%20the%20distance%2C%20theatrical%20warm%20amber%20and%20copper%20tones%2C%20moody%20high%20contrast%2C%20stylized%20editorial%20aesthetic%20with%20soft%20film%20grain%2C%20no%20readable%20text%2C%20no%20identifiable%20face%2C%20generous%20negative%20space%20at%20top&width=900&height=1200&seq=hero-cover-02&orientation=portrait",
  },
  {
    tag: "街头 · 实录",
    title: "街头美食挑战翻车，汤汁溅上镜头的瞬间",
    source: "街头实录馆",
    time: "1 小时前",
    views: "实时围观 96 万",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20photo%20of%20a%20street%20food%20challenge%20freeze%20frame%2C%20a%20burst%20of%20soup%20and%20steam%20exploding%20toward%20the%20camera%20lens%2C%20warm%20market%20stall%20string%20lights%20bokeh%20behind%2C%20dramatic%20warm%20orange%20and%20red%20tones%2C%20high%20contrast%20cinematic%20lighting%2C%20stylized%20editorial%20aesthetic%20with%20soft%20film%20grain%2C%20no%20readable%20text%2C%20no%20identifiable%20face%2C%20generous%20negative%20space%20at%20top&width=900&height=1200&seq=hero-cover-03&orientation=portrait",
  },
  {
    tag: "带货 · 现场",
    title: "带货话术突然卡壳，镜头前只剩一声长叹",
    source: "带货现场",
    time: "2 小时前",
    views: "实时围观 64 万",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20photo%20of%20a%20product%20live%20sales%20studio%20freeze%20frame%2C%20a%20headset%20microphone%20and%20a%20product%20box%20hovering%20awkwardly%2C%20cluttered%20desk%20with%20floating%20receipts%20and%20price%20tags%20mid%20air%2C%20warm%20studio%20lights%20in%20rust%20and%20amber%20tones%2C%20high%20contrast%20dramatic%20lighting%2C%20stylized%20editorial%20aesthetic%20with%20soft%20film%20grain%2C%20no%20readable%20text%2C%20no%20identifiable%20face%2C%20generous%20negative%20space%20at%20top&width=900&height=1200&seq=hero-cover-04&orientation=portrait",
  },
];

export const rankList = [
  {
    title: "发布会大屏变回开机画面，观众排队拍照纪念",
    category: "科技首发",
    heat: 98.6,
    delta: "↑ 12.4",
    summary: "演示刚开始 40 秒，主屏直接退回桌面，现场安静到能听见快门声。",
  },
  {
    title: "挑战 100 秒拼装新品，倒数读到一半先崩了",
    category: "街头挑战",
    heat: 92.1,
    delta: "↑ 8.2",
    summary: "计时器还在走，手里的零件已经散了一地，围观者集体倒吸一口凉气。",
  },
  {
    title: "智能家电连环断电，主持人情绪管理彻底失败",
    category: "直播现场",
    heat: 87.4,
    delta: "↑ 5.6",
    summary: "从电视到冰箱一路黑屏，主持人摘下耳麦深呼吸的那一幕被无限回放。",
  },
  {
    title: "无人机表演编队突发撞机，灯阵瞬间黑了一片",
    category: "户外实况",
    heat: 81.9,
    delta: "↓ 2.3",
    summary: "几百架灯光刚要摆出图形，半边编队直接熄火坠落，现场只剩惊呼。",
  },
  {
    title: "新机防水实测当场翻车，评测博主一句话没说",
    category: "评测打脸",
    heat: 76.2,
    delta: "↑ 3.8",
    summary: "泡水箱刚端起十秒，屏幕就飘出雾气，直播间观众瞬间刷爆弹幕。",
  },
];

export const rankFeature = {
  title: "一周霸榜：全网最惨的一次串台",
  label: "本周爆款名场面",
  views: "3 天累计围观 1,284 万",
  tag: "上榜第 7 天",
  cover:
    "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20photo%20of%20two%20colliding%20live%20broadcast%20sets%20freeze%20frame%2C%20two%20overlapping%20studio%20screens%20and%20microphone%20booms%20clashing%20mid%20air%2C%20warm%20and%20green%20studio%20glow%20colliding%2C%20dramatic%20high%20contrast%20cinematic%20lighting%2C%20stylized%20editorial%20aesthetic%20with%20soft%20film%20grain%2C%20no%20readable%20text%2C%20no%20identifiable%20face%2C%20composition%20with%20clear%20negative%20space%20at%20top&width=800&height=1000&seq=rank-feature-cover&orientation=portrait",
};

export const moments = [
  {
    label: "第 08 期",
    title: "掌声骤然停下的一瞬",
    caption: "所有人同时安静，只有灯光还在走位。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20photo%20of%20an%20auditorium%20going%20silent%20freeze%20frame%2C%20drifting%20confetti%20hanging%20motionless%20in%20mid%20air%20over%20empty%20stage%20chairs%2C%20warm%20amber%20theater%20lighting%2C%20high%20contrast%20cinematic%20mood%2C%20stylized%20editorial%20aesthetic%20with%20soft%20film%20grain%2C%20no%20readable%20text%2C%20no%20identifiable%20face%2C%20negative%20space%20at%20top&width=800&height=1000&seq=moment-cover-01&orientation=portrait",
  },
  {
    label: "第 07 期",
    title: "摄像头前的一口长叹",
    caption: "所有话术都断在这里，导演喊了三次卡。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20photo%20of%20a%20big%20studio%20camera%20lens%20with%20warm%20bokeh%20light%20and%20a%20detached%20microphone%20floating%20nearby%2C%20an%20empty%20director%20chair%20in%20frame%2C%20dramatic%20warm%20orange%20and%20rust%20tones%2C%20high%20contrast%20cinematic%20lighting%2C%20stylized%20editorial%20aesthetic%20with%20soft%20film%20grain%2C%20no%20readable%20text%2C%20no%20identifiable%20face%2C%20negative%20space%20at%20top&width=800&height=1000&seq=moment-cover-02&orientation=portrait",
  },
  {
    label: "第 06 期",
    title: "麦克风失灵的三十秒",
    caption: "开口只有电流声，台上台下一起尬在原地。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20photo%20of%20a%20malfunctioning%20microphone%20emitting%20visible%20electric%20static%20in%20a%20dim%20venue%2C%20cables%20coiling%20in%20the%20air%2C%20warm%20amber%20and%20deep%20brown%20stage%20tones%2C%20high%20contrast%20cinematic%20moody%20lighting%2C%20stylized%20editorial%20aesthetic%20with%20soft%20film%20grain%2C%20no%20readable%20text%2C%20no%20identifiable%20face%2C%20negative%20space%20at%20top&width=800&height=1000&seq=moment-cover-03&orientation=portrait",
  },
  {
    label: "第 05 期",
    title: "台下滚落的遥控器",
    caption: "演示棒失手脱手，一路滚到摄像机脚边。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20photo%20of%20a%20remote%20controller%20rolling%20across%20a%20polished%20stage%20floor%20toward%20a%20camera%20tripod%2C%20warm%20reflections%20and%20spotlight%20beams%2C%20dramatic%20warm%20amber%20and%20rust%20tones%2C%20high%20contrast%20cinematic%20lighting%2C%20stylized%20editorial%20aesthetic%20with%20soft%20film%20grain%2C%20no%20readable%20text%2C%20no%20identifiable%20face%2C%20negative%20space%20at%20top&width=800&height=1000&seq=moment-cover-04&orientation=portrait",
  },
  {
    label: "第 04 期",
    title: "倒带一般的沉默",
    caption: "重播三遍，观众才发现笑点其实在第二遍。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20photo%20of%20a%20rewinding%20videotape%20reel%20with%20light%20streaks%20and%20a%20pause%20symbol%20of%20light%20floating%20in%20a%20dark%20edit%20suite%2C%20warm%20amber%20screen%20glow%2C%20dramatic%20high%20contrast%20cinematic%20lighting%2C%20stylized%20editorial%20aesthetic%20with%20soft%20film%20grain%2C%20no%20readable%20text%2C%20no%20identifiable%20face%2C%20negative%20space%20at%20top&width=800&height=1000&seq=moment-cover-05&orientation=portrait",
  },
  {
    label: "第 03 期",
    title: "溅上镜头的泡泡",
    caption: "彩排一切顺利，正式录制却一团糟。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20photo%20of%20soap%20bubbles%20bursting%20directly%20against%20a%20camera%20lens%20creating%20refraction%20prisms%2C%20warm%20backlight%20through%20translucent%20bubbles%2C%20rust%20and%20honey%20tones%2C%20macro%20high%20contrast%20cinematic%20look%2C%20stylized%20editorial%20aesthetic%20with%20soft%20film%20grain%2C%20no%20readable%20text%2C%20no%20identifiable%20face%2C%20negative%20space%20at%20top&width=800&height=1000&seq=moment-cover-06&orientation=portrait",
  },
];

export const archiveFeed = [
  {
    category: "字幕翻车",
    tagStyle: "primary",
    time: "今日 09:12",
    title: "AI 生成字幕当场把台词念串，现场笑到失控",
    summary:
      "实时字幕把“请注意”认成“请拉闸”，主持人还没反应过来，弹幕已经替他宣布直播结束。",
    views: "围观 1.2 万",
    likes: "点赞 3,406",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20landscape%20photo%20of%20a%20live%20caption%20screen%20displaying%20glitchy%20misrecognized%20subtitles%20with%20a%20broadcast%20studio%20in%20soft%20focus%20behind%2C%20warm%20amber%20control%20room%20glow%2C%20high%20contrast%20cinematic%20lighting%2C%20stylized%20editorial%20aesthetic%20with%20soft%20film%20grain%2C%20no%20readable%20text%2C%20no%20identifiable%20face&width=1200&height=750&seq=archive-cover-01&orientation=landscape",
  },
  {
    category: "舞台事故",
    tagStyle: "accent",
    time: "昨日 22:40",
    title: "开场曲放了三次都没响，全场跟着主持人干等",
    summary:
      "导演组试图切备机，结果每切一次音乐就消失一次，灯光老师干脆自己唱了起来。",
    views: "围观 8,430",
    likes: "点赞 2,108",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20landscape%20photo%20of%20an%20empty%20dark%20stage%20with%20a%20single%20glowing%20speaker%20and%20silhouetted%20stagehands%20rushing%2C%20warm%20amber%20and%20deep%20brown%20tones%2C%20dramatic%20high%20contrast%20cinematic%20lighting%2C%20stylized%20editorial%20aesthetic%20with%20soft%20film%20grain%2C%20no%20readable%20text%2C%20no%20identifiable%20face&width=1200&height=750&seq=archive-cover-02&orientation=landscape",
  },
  {
    category: "实测打脸",
    tagStyle: "secondary",
    time: "昨日 18:05",
    title: "号称十级防水的设备，泡了八秒就开始冒泡",
    summary:
      "评测从信心满满到默默抽出纸巾，前后不到一分钟，评论区已经开始补刀。",
    views: "围观 6,120",
    likes: "点赞 1,765",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20landscape%20photo%20of%20a%20water%20testing%20tank%20with%20a%20device%20sinking%20and%20bubbles%20rising%2C%20splashes%20frozen%20in%20air%20under%20warm%20workshop%20lighting%2C%20rust%20and%20honey%20tones%2C%20high%20contrast%20cinematic%20lighting%2C%20stylized%20editorial%20aesthetic%20with%20soft%20film%20grain%2C%20no%20readable%20text%2C%20no%20identifiable%20face&width=1200&height=750&seq=archive-cover-03&orientation=landscape",
  },
  {
    category: "直播现场",
    tagStyle: "primary",
    time: "前天 21:30",
    title: "连线到一半对方忽然消失，画面只剩空椅子",
    summary:
      "嘉宾讲到一半起身离席，镜头稳稳对准一把空椅子，主持人硬聊了四分钟。",
    views: "围观 5,870",
    likes: "点赞 1,402",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20landscape%20photo%20of%20a%20talking%20heads%20studio%20set%20with%20one%20empty%20guest%20chair%20under%20a%20warm%20spotlight%20and%20another%20chair%20with%20a%20looping%20cable%20left%20behind%2C%20warm%20amber%20tones%2C%20high%20contrast%20cinematic%20mood%2C%20stylized%20editorial%20aesthetic%20with%20soft%20film%20grain%2C%20no%20readable%20text%2C%20no%20identifiable%20face&width=1200&height=750&seq=archive-cover-04&orientation=landscape",
  },
];

export const archiveMore = [
  {
    category: "街头挑战",
    time: "09-02",
    title: "百秒叠杯挑战，计时器归零前碎了一地",
  },
  {
    category: "带货现场",
    time: "09-01",
    title: "镜头前开箱，盒子一开众人集体沉默",
  },
  {
    category: "科技首发",
    time: "08-31",
    title: "演示手势识别，手臂抬到一半系统没反应",
  },
  {
    category: "户外实况",
    time: "08-30",
    title: "测光无人机当天风向突变，全程逆风挣扎",
  },
];

export const topics = [
  {
    icon: "ri-live-line",
    title: "直播翻车实录",
    desc: "直播现场每一帧失控，都值得被一帧帧回放。",
    count: "收录 3,204 段",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20landscape%20photo%20of%20a%20live%20stream%20control%20room%20with%20multiple%20glowing%20monitors%20showing%20static%20and%20a%20red%20REC%20light%20reflecting%20on%20glass%2C%20warm%20amber%20tones%2C%20high%20contrast%20cinematic%20lighting%2C%20stylized%20editorial%20aesthetic%20with%20soft%20film%20grain%2C%20no%20readable%20text%2C%20no%20identifiable%20face&width=1000&height=620&seq=topic-cover-01&orientation=landscape",
  },
  {
    icon: "ri-sparkling-2-line",
    title: "舞台名场面",
    desc: "掌声与沉默之间，藏着全网最精彩的十秒。",
    count: "收录 1,876 段",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20landscape%20photo%20of%20a%20grand%20stage%20with%20hanging%20drifting%20confetti%20frozen%20and%20focused%20spotlights%2C%20warm%20amber%20and%20copper%20tones%2C%20high%20contrast%20cinematic%20lighting%2C%20stylized%20editorial%20aesthetic%20with%20soft%20film%20grain%2C%20no%20readable%20text%2C%20no%20identifiable%20face&width=1000&height=620&seq=topic-cover-02&orientation=landscape",
  },
  {
    icon: "ri-roadster-line",
    title: "街头实录馆",
    desc: "日常高能现场，总在转角的下一秒发生。",
    count: "收录 2,742 段",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20landscape%20photo%20of%20a%20city%20street%20corner%20with%20a%20warm%20market%20stall%20and%20bursting%20water%20splash%20frozen%20in%20air%2C%20street%20lamp%20bokeh%2C%20warm%20orange%20and%20rust%20tones%2C%20high%20contrast%20cinematic%20lighting%2C%20stylized%20editorial%20aesthetic%20with%20soft%20film%20grain%2C%20no%20readable%20text%2C%20no%20identifiable%20face&width=1000&height=620&seq=topic-cover-03&orientation=landscape",
  },
  {
    icon: "ri-flashlight-line",
    title: "首发事故清单",
    desc: "新品首发的意外，往往比参数更有记忆点。",
    count: "收录 1,029 段",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20landscape%20photo%20of%20a%20product%20launch%20stage%20with%20a%20large%20screen%20flashing%20glitch%20light%20and%20a%20fallen%20spotlight%20fixture%2C%20warm%20amber%20and%20rust%20tones%2C%20high%20contrast%20cinematic%20lighting%2C%20stylized%20editorial%20aesthetic%20with%20soft%20film%20grain%2C%20no%20readable%20text%2C%20no%20identifiable%20face&width=1000&height=620&seq=topic-cover-04&orientation=landscape",
  },
];

export const stats = [
  { value: "1.28万", unit: "+", label: "已收录名场面与翻车记录" },
  { value: "356", unit: "万", label: "本周全网累计围观次数", accent: true },
  { value: "9400", unit: "+", label: "来自全网吃瓜群众的情报线索" },
  { value: "87", unit: "条", label: "今日现场实录持续更新中" },
];

export const tagCloud = [
  "发布会翻车",
  "带货名场面",
  "字幕事故",
  "演示打脸",
  "直播宕机",
  "防水实测",
  "无人机撞机",
  "开箱沉默",
  "街头挑战",
  "舞台事故",
  "串台实录",
  "回放三连",
];